import { ReportDesign } from '../../models/end-client-reporting-package';
import { DecipherDatamap, RespondentRecord, SurveyLayout, parseDatamap } from './report-aggregation';

import designFile from './fixtures/report-design.json';
import datamapFile from './fixtures/datamap.json';
import dataFile from './fixtures/data.json';

// The checked-in sample survey, which the theme preview draws a theme on when no report or
// template is chosen to preview it against.

export function fixtureDesign(): ReportDesign {
  return designFile as unknown as ReportDesign;
}

export function fixtureRecords(): RespondentRecord[] {
  return dataFile as RespondentRecord[];
}

let cachedLayout: SurveyLayout | null = null;

export function fixtureSurveyLayout(): SurveyLayout {
  if (!cachedLayout) cachedLayout = parseDatamap(datamapFile as unknown as DecipherDatamap);
  return cachedLayout;
}
